const PODCAST_CATEGORIES = [
  'Voices',
  'Giving Voice to Depression',
  'Giving Voice to Addiction',
  'Giving Voice to Mental Health',
  'Recoverycast'
]

module.exports = { PODCAST_CATEGORIES }
